import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** DOM id on `MainLayout`’s scroll column (`overflow: auto`). The app shell scrolls here, not `window`. */
export const MAIN_SCROLL_CONTAINER_ID = "main-scroll-container";

/**
 * Scrolls to the top when the location changes (pathname or search).
 * Must be rendered inside `<Router>`.
 */
export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const main = document.getElementById(MAIN_SCROLL_CONTAINER_ID);
    if (main) {
      main.scrollTop = 0;
      main.scrollLeft = 0;
    }
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search]);

  return null;
}
